import { runDemo } from "../shared/demoRunner";
import { createVertexDataScene } from "./scene";

runDemo({ createScene: createVertexDataScene });
